import axios from 'axios';
import qs from 'qs';
import 'react-toastify/dist/ReactToastify.css';
import { toast, } from 'react-toastify';
import { useState, useEffect } from 'react';
import styles from './App.module.scss';
import { savedToast, saveFormToast } from './Components/Toasts';
import { itemApiUrl, offersApiUrl } from './user-config';
import { Outlet } from 'react-router';


export enum Mode {
  ALL_OFFERS = 'allOffers',
  THE_OFFER = 'theOffer',
  MAIN = 'main',
  CALCULATOR = 'calculator',
}

export type ItemType = {
  status: ItemStatus,
  title: string,
  article_id: string,
  material: string,
  period: string,
  startPrice: number,
  finalPrice: number,
  img_url: string,
  isSelected: boolean,
  isLoading: boolean,
};

export type OfferInfoType = {
  client: string,
  manager: string,
  createdAt: EpochTimeStamp,
  id: string,
  offerId: string,
};

type ItemsType = {
  items: ItemType[]
};

export type OfferType = OfferInfoType & ItemsType;

type ItemApiDataType = {
  article_id: string,
  img_url: string,
  item_status: string,
  last_price: string
  material: string,
  period: string,
  price: string,
  status_code: number,
  title: string,
};


export enum ItemStatus {
  AVAILAIBLE = 'В наличии',
  SOLD = 'Продано',
  RESERVED = 'Резерв',
};


function App() {

  const [items, setItems] = useState<ItemType[]>([]);
  const [offerInfo, setOfferInfo] = useState<OfferInfoType>({ client: '', manager: '', createdAt: 0, id: '', offerId: '' });

  useEffect(() => {
    let itemsJSON = window.localStorage.getItem('offerItems');
    if (window.location.search) {
      addItemsFromOffer(String(qs.parse(window.location.search.substring(1)).ofId))
    } else if (itemsJSON) {
      setItems(JSON.parse(itemsJSON))
    }
  }, []);

  useEffect(() => {
    window.localStorage.setItem('offerItems', JSON.stringify(items))
  }, [items]);


  const addItemsFromOffer = async (id: String) => {
    axios.get(`${offersApiUrl}/?ofId=${id}`)
      .then(res => {
        setItems(res.data[0].items);
        setOfferInfo({ client: res.data[0].client, manager: res.data[0].manager, createdAt: res.data[0].createdAt, id: res.data[0].id, offerId: res.data[0].offerId });
      })
      .catch(error => console.log(error));
  };


  const getItemsFromSearch = async (text: string) => {

    const idsFromText = text.match(/\d+_\d+/g);
    const articleIds = Array.from(new Set(idsFromText));        // make unique

    if (!articleIds.length) {
      alert('Не найдены артикулы в строке поиска: "' + text + '"');
      console.log('No articles in search value : "', text, '"');
      return
    } else if (articleIds.length !== idsFromText?.length) {
      alert('Дублирующиеся артикулы удалены из поиска');
    };

    const alreadyAddedIds = articleIds.filter(id => items.find(el => el.article_id === id))
    alreadyAddedIds && alreadyAddedIds.length && console.log(`${alreadyAddedIds.length > 1 ? 'Items' : 'Item'} ${alreadyAddedIds} ${alreadyAddedIds.length > 1 ? 'have' : 'has'} already added`)
    const addingIds = articleIds.filter(id => !items.find(el => el.article_id === id))

    if (addingIds) {
      const newItems = addingIds
        .filter(id => !items.find(el => el.article_id === id))
        .map((id) =>
        ({
          status: ItemStatus.RESERVED,
          article_id: id,
          title: "title",
          material: "material",
          period: "period",
          startPrice: 0,
          finalPrice: 0,
          img_url: "img_url",
          isSelected: false,
          isLoading: true,
        }));

      setItems(prev => [...prev, ...newItems]);

      for (const id of addingIds) {
        try {
          const { data }: { data: ItemApiDataType } = await axios.get(`${itemApiUrl}/${id}`)
          let nowStatus;
          switch (data.item_status) {
            case "В наличии": nowStatus = ItemStatus.AVAILAIBLE; break;
            case "Продано": nowStatus = ItemStatus.SOLD; break;
            case "Резерв": nowStatus = ItemStatus.RESERVED; break;
            default: nowStatus = ItemStatus.RESERVED;
          };

          let nowItem: ItemType = {
            status: nowStatus,
            article_id: id,
            title: data.title,
            material: data.material,
            period: data.period,
            startPrice: nowStatus !== ItemStatus.SOLD ? Number(data.price.replaceAll(" ", "")) : 0,
            finalPrice: nowStatus !== ItemStatus.SOLD ? Number(data.price.replaceAll(" ", "")) : 0,
            img_url: data.img_url,
            isSelected: nowStatus !== ItemStatus.SOLD && true,
            isLoading: false,
          }
          setItems(prev => {
            prev[prev.findIndex((item) => (item.article_id === id))] = nowItem;
            return [...prev]
          });
        } catch (error) {
          console.log(`не удалось добавить предмет ${id}`, error)
          deleteItem(id);
        };
      }
    };
  };

  const deleteItem = (id: string) => {
    setItems(prev => [...prev.filter(item => !(item.article_id === id))])
    console.log(`Item ${id} deleted`)
  };

  const clearItems = () => {
    console.log(`All items deleted`);
    window.location.href = window.location.origin;
    setItems([])
  };

  const select = (id: string) => {
    let item = items.find((item) => (item.article_id === id))
    if (item) {
      item.isSelected = !item.isSelected;
      setItems([...items])
    };
  };

  const makeDiscount = (id: string, newPrice: number) => {
    let item = items.find((item) => (item.article_id === id))
    if (item) {
      item.finalPrice = newPrice;
      setItems([...items]);
    };
  };

  const saveNewOffer = () => {
    toast.dismiss();
    window.history.replaceState(null, '', window.location.pathname);

    const pushOffer = (saveFormData: { manager: string, client: string }) => {

      const offerId = `of${new Date().getTime() - 720000000000}b`;
      const data = Object.assign(saveFormData, { offerId, items, createdAt: Math.round(Date.now() / 1000), });

      axios.post(offersApiUrl, data)
        .then((res) => {
          setOfferInfo({ client: res.data.client, manager: res.data.manager, createdAt: res.data.createdAt, id: res.data.id, offerId: res.data.offerId });
          toast.dismiss();
          window.history.pushState(null, '', `/?ofId=${offerId}`);
          console.log(`Offer ${offerId} saved: ${window.location.origin}/?ofId=${offerId}`);
          const newOfferURL = `${window.location.origin}/?ofId=${offerId}`;
          navigator.clipboard.writeText(newOfferURL);
          savedToast(newOfferURL);
        })
        .catch(error => console.error(error));
    };
    saveFormToast(pushOffer);
  };

  const updateOffer = () => {
    axios.put(`${offersApiUrl}/${offerInfo.offerId}`, items)
      .then(() => {
        alert("КП успешно обновлено");
      })
      .catch(error => { alert("!!! !!! !!! !!! !!! !!! !!! !!! !!! !!! !! \nПроизошла ошибка. \nНе удалось обновить КП \n!!! !!! !!! !!! !!! !!! !!! !!! !!!"); console.error(error) });
  };


  return (
    <div className={styles.App}>

      <Outlet context={{
        items,
        offerInfo,
        getItemsFromSearch, saveNewOffer, clearItems, updateOffer,
        select, deleteItem, makeDiscount
      }} />

    </div >
  );
};

export default App;
